/**
 * Poll attachment rules for create/edit post (client-side UX).
 * Mirror backend/census_data/post_attachments.py — update both together.
 */

export const POLL_MIN_OPTIONS = 2;
export const POLL_MAX_OPTIONS = 4;
export const POLL_OPTION_MAX_LENGTH = 120;

export const POLL_LOCKED_TITLE = "Cannot change poll";
export const POLL_LOCKED_MESSAGE =
  "Polls cannot be removed or changed after votes have been cast.";

export function createEmptyPollOptions() {
  return Array(POLL_MIN_OPTIONS).fill("");
}

export function getFilledPollOptions(rawOptions) {
  return (rawOptions ?? []).map((o) => String(o).trim()).filter(Boolean);
}

/**
 * @returns {{ ok: true, cleaned: string[] } | { ok: false, error: string }}
 */
export function validatePollOptionsForSubmit(rawOptions) {
  const filled = getFilledPollOptions(rawOptions);

  if (filled.length < POLL_MIN_OPTIONS) {
    return { ok: false, error: `Polls require at least ${POLL_MIN_OPTIONS} options.` };
  }
  if (filled.length > POLL_MAX_OPTIONS) {
    return { ok: false, error: `Polls can have at most ${POLL_MAX_OPTIONS} options.` };
  }
  for (let i = 0; i < filled.length; i++) {
    if (filled[i].length > POLL_OPTION_MAX_LENGTH) {
      return {
        ok: false,
        error: `Each poll option must be ${POLL_OPTION_MAX_LENGTH} characters or less.`,
      };
    }
  }
  return { ok: true, cleaned: filled };
}

export function isPollLockedByVotes({ isEditMode, pollHasVotes }) {
  return Boolean(isEditMode && pollHasVotes);
}

export function postHasPollAttachment(post) {
  return (post?.poll_options?.length ?? 0) > 0;
}

export function derivePollHasVotesFromPost(post) {
  return (post?.poll_total_votes ?? 0) > 0;
}

export function hasMinimumPollOptions(rawOptions) {
  return getFilledPollOptions(rawOptions).length >= POLL_MIN_OPTIONS;
}
